import React from 'react'
import Button from '@material-ui/core/Button'
import Link from './Link'

export default props => (
  <Button {...props} component={Link} />
)
